import { __extends } from "tslib";
import { TextJustifier } from './TextJustifier';
var SpaceJustifier = /** @class */ (function (_super) {
    __extends(SpaceJustifier, _super);
    function SpaceJustifier(locale, lineJustification, letterSpacing) {
        if (locale === void 0) { locale = 'en'; }
        if (lineJustification === void 0) { lineJustification = 'unjustified'; }
        if (letterSpacing === void 0) { letterSpacing = false; }
        var _this = _super.call(this, locale, lineJustification) || this;
        _this._letterSpacing = !!letterSpacing;
        return _this;
    }
    Object.defineProperty(SpaceJustifier.prototype, "letterSpacing", {
        // AS -> JS Bindings
        get: function () {
            return this._letterSpacing;
        },
        set: function (value) {
            this._letterSpacing = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpaceJustifier.prototype, "minimumSpacing", {
        get: function () {
            return this._minimumSpacing;
        },
        set: function (value) {
            this._minimumSpacing = +value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpaceJustifier.prototype, "optimumSpacing", {
        get: function () {
            return this._optimumSpacing;
        },
        set: function (value) {
            this._optimumSpacing = +value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpaceJustifier.prototype, "maximumSpacing", {
        get: function () {
            return this._maximumSpacing;
        },
        set: function (value) {
            this._maximumSpacing = +value;
        },
        enumerable: true,
        configurable: true
    });
    SpaceJustifier.forceNativeConstructor = true;
    SpaceJustifier.forceNativeMethods = true;
    return SpaceJustifier;
}(TextJustifier));
export { SpaceJustifier };
